import React, { useState } from "react";
import "./../../components/LoginForm/LoginForm.scss";
import { Input } from "../../common/Input/Input";
import { Button } from "../../common/Button/Button";
import logo from "./../../assets/logo.png";
import api from "../../utils/api";
import { toast } from "react-toastify";
import { useLocation, useHistory } from "react-router-dom";

export default function ResetPasswordForm(props) {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const location = useLocation();
  const history = useHistory();

  const resetPassword = () => {
    const parts = location.search.split('=');
    let token = '';
    if (parts.length === 2) {
      token = parts[1];
    } else {
      console.error("Invalid or missing token in query.");
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (password.length < 8) {
      setError('Password length should be atleast 8 characters');
      return;
    }
    setError(null);
    api.resetPassword({ password, token }).then((response) => {
      toast('Password set successfully.', { autoClose: 5000, type: toast.TYPE.SUCCESS });
      history.push('/login');
    })
  }

  return (
    <div className="login-container">
      <div className="login-form-container">
        <div className="login-form">
          <div className="text-center mt10 mb20">
            <img
              alt="deasra-logo"
              src={logo}
              className="h40 mb20 logo-img"
            />
          </div>
          <div className="text-help mb10">Set New Password.</div>
          <Input
            type="password"
            name="password"
            className="password"
            placeholder="New Password"
            onChange={({ target: { name, value } }) => setPassword(value)}
          />
          <Input
            type="password"
            name="confirmpassword"
            className="password"
            placeholder="Confirm New Password"
            onChange={({ target: { name, value } }) => setConfirmPassword(value)}
          />
          <div className="text-help mb10">
            Minimum password length is 8 characters.
          </div>
          {error ? (
            <div className="form-error mt10">{error}</div>
          ) : null}
          <div className="flex justify-content-stretch mt20 mb20">
            <Button
              className="w100p pt10 pb10"
              primary
              onClick={resetPassword}
            >
              Set Password
            </Button>
          </div>
          <div className="flex justify-content-center mt20">
            <a href="/login" className="ml10 text-link cursor-pointer">
              Go back to Login Page
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
